import { render, staticRenderFns } from "./partialHeader.vue?vue&type=template&id=6fcd84a3&scoped=true&"
import script from "./partialHeader.vue?vue&type=script&lang=js&"
export * from "./partialHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd84a3",
  null
  
)

export default component.exports